// Write your code here
import './index.css'

const MatchCard = props => {
  const {details} = props
  const {
    umpires,
    result,
    manOfTheMatch,

    date,
    venue,
    competingTeam,
    competingTeamLogo,
    firstInnings,
    secondInnings,
    matchStatus,
  } = details
  return (
    <li className="match_card">
      <img
        className="match_card_image"
        src={competingTeamLogo}
        alt={`competing team ${competingTeam}`}
      />
      <p className="match_card_heading">{competingTeam}</p>
      <p>{result}</p>
      {matchStatus === 'Won' ? (
        <p className="won_status">{matchStatus}</p>
      ) : (
        <p className="lost_status">{matchStatus}</p>
      )}
    </li>
  )
}
export default MatchCard
